const imp = () => import(/* webpackChunkName: "loadSprite_IM_terminal"*/  "../sprite/loadSprite_IM_terminal");
const loadMap_app_line: { [key: string]: () => Promise<any> } = {
  "Icon-Bida2-o": imp,
  "Icon-Messagecenter2-o": imp,
  "Icon-addgroup2-o": imp,
  "Icon-group3-o": imp,
  "Icon-maillist2-o": imp,
  "Icon-Messagecenter2": imp,
  "Icon-group3": imp,
  "Icon-more3": imp,
  "Icon-maillist2": imp,
  "Icon-topicdiscussion": imp,
  "Icon-topicend": imp,
  "Icon-Groupchatsharing": imp,
  "Icon-Matterstatus": imp,
  "Icon-putaway": imp,

}
export default loadMap_app_line;
